// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GY2s","col":"styles_col__4UwHY"};